﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CONFIG } from './core/config';
import { catchError, finalize } from 'rxjs/operators';
import { SpinnerService } from './core/spinner/spinner.service';
import { NewsletterModel } from './core/models/newsletter-model';
import { ExceptionService } from './core/services/exception.service';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    subscribeToNewsletter(data: NewsletterModel): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.subscribeToNewsletter, data)
            .pipe(
                catchError( this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadUserManual(): Observable<any> {
        this._spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post<Blob>(CONFIG.baseUrls.downloadUserManual,null,{ headers, responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadTermsAndRequirements(): Observable<any> {
        this._spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post<Blob>(CONFIG.baseUrls.downloadTermsAndRequirements,null, { headers, responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadPrivacyPolicy(): Observable<any> {
        this._spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post<Blob>(CONFIG.baseUrls.downloadPrivacyPolicy,null, { headers, responseType: 'blob' as 'json' })
            .pipe(
                catchError( this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadHelpContacts(): Observable<any> {
        this._spinnerService.show();
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this._http.post<Blob>(CONFIG.baseUrls.downloadHelpContacts,null, { headers, responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
}